<template>
  <div class="account-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t("system.Account.Return_to_account_list")}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100" :model="formValidate" :rules="ruleValidate">
            <FormItem :label="$t('system.Account.User_name')" prop="username">
              <Input class="info" v-model="formValidate.username" :placeholder="$t('system.Account.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('system.Account.Name')" prop="name">
              <Input class="info" v-model="formValidate.name" :placeholder="$t('system.Account.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('system.Account.Worker_number')">
              <Input class="info" v-model="formValidate.workNo" :placeholder="$t('system.Account.please_enter')"></Input>
            </FormItem>
            <!-- <FormItem :label="$t('system.Account.Department')" prop="departmentID">
              <Select class="info" v-model="formValidate.departmentID" :value="formValidate.departmentID">
                <Option v-for="item in formValidate.department" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem> -->
            <FormItem :label="$t('system.Account.Role')" prop="roleID">
              <Select class="info" v-model="formValidate.roleID" :value="formValidate.roleID">
                <Option v-for="item in formValidate.role" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('system.Account.Telephone')">
              <Input class="info" v-model="formValidate.phone" :placeholder="$t('system.Account.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('system.Account.Email')">
              <Input class="info" v-model="formValidate.eMail" :placeholder="$t('system.Account.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('system.Account.QQ')">
              <Input class="info" v-model="formValidate.qq" :placeholder="$t('system.Account.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('system.Account.Wechat')">
              <Input class="info" v-model="formValidate.wechat" :placeholder="$t('system.Account.please_enter')"></Input>
            </FormItem>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t("system.Account.save")}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'AccountEdit',
  data () {
    return {
      formValidate: {
        id: 0,
        username: '',
        name: '',
        workNo: '',
        departmentID: '0',
        roleID: '',
        phone: '',
        eMail: '',
        qq: '',
        wechat: '',
        department: [],
        list: [],
        check: false,
        working: 1,
        language: '',
        role: []
      },
      ruleValidate: {
        username: [
          { required: true, message: this.$t('system.Account.User_name_message'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('system.Account.Name_message'), trigger: 'blur' }
        ],
        departmentID: [
          { required: true, message: this.$t('system.Account.Role_message'), pattern: /.+/, trigger: 'change' }
        ],
        roleID: [
          { required: true, message: this.$t('system.Account.Department_message'), pattern: /.+/, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('system.Account.New_account') : this.$t('system.Account.edit_account')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let account
      this.formValidate.check = false
      if (this.formValidate.list !== undefined) {
        for (let i = 0; i < this.formValidate.list.length; i++) {
          if (this.formValidate.list[i].username === 'admin') {
            this.formValidate.language = this.formValidate.list[i].language
          }
          if (this.formValidate.list[i].username === this.formValidate.username && this.formValidate.list[i].id !== this.formValidate.id) {
            this.formValidate.check = true
          }
        }
      }
      if (this.formValidate.check === true) {
        const title = this.$t('system.Account.error')
        const content = this.$t('system.Account.error_message1')
        this.$Modal.error({
          title: title,
          content: content
        })
      } else if (this.formValidate.username !== '' && this.formValidate.name !== '' && this.formValidate.departmentID !== '' && this.formValidate.roleID !== '') {
        account = {
          id: this.formValidate.id,
          username: this.formValidate.username,
          name: this.formValidate.name,
          workNo: this.formValidate.workNo,
          department: Number(this.formValidate.departmentID),
          role: Number(this.formValidate.roleID),
          phone: this.formValidate.phone,
          eMail: this.formValidate.eMail,
          qq: this.formValidate.qq,
          wechat: this.formValidate.wechat,
          working: Number(this.formValidate.working),
          language: this.formValidate.language
        }
        Api.account.save(account).then(() => {
          this.$router.push({'name': 'Account'})
        })
      } else {
        const title = this.$t('system.Account.error')
        const content = this.$t('system.Account.error_message2')
        this.$Modal.error({
          title: title,
          content: content
        })
      }
    }
  },
  mounted () {
    Api.department.list().then(res => {
      this.formValidate.department = res.departments
    })
    Api.role.list().then(res => {
      this.formValidate.role = res.roles
    })
    Api.account.list().then(res => {
      this.formValidate.list = res.accounts
    })
  },
  beforeRouteEnter (to, from, next) {
    let id = to.params.id
    if (id !== 0) {
      Api.account.get(Number(id)).then(res => {
        next(vm => {
          let a = res.account
          vm.formValidate.id = a.id
          vm.formValidate.username = a.username
          vm.formValidate.name = a.name
          vm.formValidate.workNo = a.workNo
          vm.formValidate.departmentID = a.department
          vm.formValidate.roleID = a.role
          vm.formValidate.phone = a.phone
          vm.formValidate.eMail = a.eMail
          vm.formValidate.qq = a.qq
          vm.formValidate.wechat = a.wechat
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .account-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// AccountEdit.vue?7a7c405e